import { Switch } from "react-router-dom";
import Route from "./Route";

import Home from "../pages/Home";
import Login from "../pages/Login";
import Signup from "../pages/Signup";
import Dashboard from "../pages/Dashboard";
import { AnimatePresence } from "framer-motion";
import PageNotFound from "../pages/PageNotFound";
import Map from "../pages/Map";
import Battle from "../pages/Battle";
import CreateChar from "../pages/CreateChar";

const Routes = () => {
  return (
    <AnimatePresence>
      <Switch>
        <Route component={Home} exact path="/" />
        <Route component={Login} path="/login" />
        <Route component={Signup} path="/signup" />
        <Route component={Dashboard} isPrivate path="/dashboard" />
        <Route component={Map} isPrivate path="/map" />
        <Route component={Battle} isPrivate path="/battle" />
        <Route component={CreateChar} isPrivate path="/create_char" />
        <Route component={PageNotFound} />
      </Switch>
    </AnimatePresence>
  );
};

export default Routes;
